module.exports = __webpack_public_path__ + "static/media/freeRoundsDefault.27c8820c.png";